import { render, staticRenderFns } from "./metas.vue?vue&type=template&id=a741f208&scoped=true&"
import script from "./metas.vue?vue&type=script&lang=js&"
export * from "./metas.vue?vue&type=script&lang=js&"
import style0 from "./metas.vue?vue&type=style&index=0&id=a741f208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a741f208",
  null
  
)

export default component.exports